import { Component, OnInit, Input } from '@angular/core';
import { CatalogService } from '@catalog/catalog.service';
import { ToastrService } from 'ngx-toastr'

@Component({
  selector: 'app-catalog-thumbnail',
  templateUrl: './catalog-thumbnail.component.html',
  styleUrls: ['./catalog-thumbnail.component.scss']
})
export class CatalogThumbnailComponent implements OnInit {

  @Input() typeList: any;

  @Input() data: any;

  articleList = [];

  selectedType: string;

  constructor(
    private catalogService: CatalogService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
  }

  public onTypeChange(type: string) {
    this.articleList = [];
    this.selectedType = type;
    this.readArticle();
  }

  public readArticle() {
    const obj = {
      type: this.selectedType,
      year: "",
      month: ""
    };
    this.catalogService.readArticles(obj).subscribe(
      (response) => {
        if (response.status === 0) {
          this.articleList = [...response.data.articles];
        } else {
          this.toastr.error(response.error.errorMessage);
        }
      },
      (error) => {}
    );
  }

}
